<template>
  <div class="mobile-content1">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">大屏互动，科技赋能</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>
    <div class="card-show-container">
      <div
        v-for="(card, index) in cardList"
        :key="index"
        class="card"
      >
        <div
          v-if="card.cardTitle"
          class="title-container"
        >
          {{ card.cardTitle }}
        </div>
        <div class="card-image">
          <img :src="card.cardImage" :alt="card.cardAlt" />
        </div>
        <div class="card-content">
          {{ card.cardContent }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileContent1',
  data() {
    return {
      cardList: [
        {
          cardTitle: '多屏互动，方便快捷',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/dphd_17676818731410f34ec.webp',
          cardAlt: '多屏互动操作便捷的酒吧霸屏点歌系统',
          cardContent: '打破设备界限，让每位顾客都能参与其中',
        },
        {
          cardTitle: '炫酷特效，氛围无双',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/xktx_1767681873141059fbf.webp',
          cardAlt: '酒吧霸屏点歌系统效果炫酷活动现场氛围极好',
          cardContent: '科技赋能，贴合活动现场，营造炫酷氛围。',
        },
        {
          cardTitle: '趣味游戏，点燃热情',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/qwyx_1767681873140070fb8.webp',
          cardAlt: '酒吧霸屏点歌系统游戏丰富多样嗨爆现场',
          cardContent: '丰富多样的互动游戏,点燃现场热情。',
        },
        {
          cardTitle: '个性定制，专属体验',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/gxdz_1767681873141aa9284.webp',
          cardAlt: '为每一个酒吧定制专属酒吧霸屏互动点歌系统',
          cardContent: '为每一间酒吧量身打造专属互动体验。',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.mobile-content1 {
  width: 100%;
  margin-top: 40px;

  .title-container {
    height: 38px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 26px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }

  .card-show-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;
    margin-top: 32px;

    .card {
      width: 314px;
      height: 416px;
      border-radius: 12px;
      border: 2px solid #C95EFB;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: transparent;
      position: relative;

      .title-container {
        position: absolute;
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
        width: 276px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 1.2;
        background-image: url('~@/assets/image/card-title.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
      }

      .card-image {
        width: 100%;
        height: 340px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      .card-content {
        width: 100%;
        height: 76px;
        padding: 10px 18px;
        font-weight: 500;
        font-size: 19px;
        color: #FFFFFF;
        line-height: 1.3;
        text-align: left;
        display: flex;
        align-items: center;
        background: linear-gradient(270deg, #5824DE 0%, #A746D1 98.57%);
        word-break: break-word;
        white-space: normal;
      }
    }
  }
}
</style>
